import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { approveParticipantAudio, approveParticipantVideo } from '../../../av-moderation/actions';
import Button from '../../../base/ui/components/web/Button';
import { QUICK_ACTION_BUTTON } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        button: {
            backgroundColor: 'rgba(0, 107, 224, 1)',
            padding: '6px 16px',
            fontSize: '15px',
            lineHeight: '23px',
            color: 'rgba(255, 255, 255, 1)',
            marginRight: '8px'
        }
    };
});
const ParticipantQuickAction = ({ buttonType, muteAudio, participantID, participantName, stopVideo }) => {
    const { classes: styles } = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const askToUnmute = useCallback(() => {
        dispatch(approveParticipantAudio(participantID));
    }, [dispatch, participantID]);
    const allowVideo = useCallback(() => {
        dispatch(approveParticipantVideo(participantID));
    }, [dispatch, participantID]);
    switch (buttonType) {
        case QUICK_ACTION_BUTTON.MUTE: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.mute')} ${participantName}`, className: styles.button, label: t('participantsPane.actions.mute'), onClick: muteAudio(participantID), size: 'medium', testId: `mute-audio-${participantID}` }));
        }
        case QUICK_ACTION_BUTTON.ASK_TO_UNMUTE: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.askUnmuteParticipantPane')} ${participantName}`, className: styles.button, label: t('participantsPane.actions.askUnmuteParticipantPane'), onClick: askToUnmute, size: 'medium', testId: `unmute-audio-${participantID}` }));
        }
        case QUICK_ACTION_BUTTON.ALLOW_VIDEO: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.askUnmuteParticipantPane')} ${participantName}`, className: styles.button, label: t('participantsPane.actions.allowVideo'), onClick: allowVideo, size: 'medium', testId: `unmute-video-${participantID}` }));
        }
        case QUICK_ACTION_BUTTON.STOP_VIDEO: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.mute')} ${participantName}`, className: styles.button, label: t('participantsPane.actions.stopVideo'), onClick: stopVideo(participantID), size: 'medium', testId: `mute-video-${participantID}` }));
        }
        default: {
            return null;
        }
    }
};
export default ParticipantQuickAction;
